export const shippingInfoDisplayRules = {
  dispatchTime: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  deliveryScheduleNumber: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  dispatchAddress: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  termsOfDelivery: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly', 'Readlonly'],
  mannerOfTransport: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
    'Readlonly',
  ],
  shipmentPreparation: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  holdingCompany: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  parentCompany: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  ediCreated: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
};

export const currencyAndTaxDisplayRules = {
  vatHandlingCodes: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  promotionCode: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  pricingDate: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  vat: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  discounts: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  currency: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  priceList: ['Editable', 'Readlonly', 'Readlonly', 'Readlonly', 'Readlonly', 'Readlonly', 'Readlonly', 'Readlonly'],
  backlogAtPick: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
};

export const referenceInfoSourcingBacklogDisplayRules = {
  orderDate: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  requestDeliveryDate: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  handler: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  salesman: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  customerReference: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  yourOrder: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  supplier: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  supplierOrderReference: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  orderFulfilmentRule: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  availCheckAtOrderEntry: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  warehouse: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  autoSource: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  autoFulfilment: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  orderFulfill: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  completeDelivery: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  availCheckAtPicklistPrint: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  defaultWarehouse: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  firmAllocateOrder: [
    'Editable',
    'Readlonly',
    'Readlonly',
    'Readlonly',
    'Readlonly',
    'Readlonly',
    'Readlonly',
    'Readlonly',
  ],
  backlog: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  dispatchDateAdjustment: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  backlogAfterPickListConf: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  route: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  departure: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  destination: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  shippingAgent: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  defaultBtBsupplier: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  totalWeight: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  shipmentPreparation: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  transportAmount: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  pickConsolidation: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  collectionRequired: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
};

export const projectInformationFeesDisplayRules = {
  freightFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  insuranceFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  insurancePercentage: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  postageFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  administrationFees: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  invoiceFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  vatHandlingCodeOfFreight: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  vatHandlingCodeOfInsurance: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  vatHandlingCodeOfPost: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  vatHandlingCodeOfAdmFee: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  vatHandlingCodeOfInvFee: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  manualFreightFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  calculateInsurance: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  administrationFee: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  project: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  projectPhase: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  projectCostCode1: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
};

export const invoicingInfoDisplayRules = {
  documentType: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  invoiceReference: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  termsOfPayment: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  mergeInvoicing: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  invoicingCalendar: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
    'Readlonly',
  ],
  inventoryContractNumber: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  periodicInvoicing: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  holdInvoice: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  debtor: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  vatRegistrationNumber: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
};

export const addressesDisplayRules = {
  confirmation: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  shipTo: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  delivery: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  invoice: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  debtor: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
};

export const miscellaneousDisplayRules = {
  salesOrderPriorityCode: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  backOrderPriorityCode: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  standardTextNumber: [
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Editable',
    'Readlonly',
    'Readlonly',
  ],
  costCentre: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  orderPropertyCode: ['Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Editable', 'Readlonly', 'Readlonly'],
  division: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  holdOrder: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
  heldOrderLinesExist: ['Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output', 'Output'],
};

const statuses = ['0', '10', '20', '30', '40', '45', '50', '60'];

export type DisplayRulesKey =
  | keyof typeof shippingInfoDisplayRules
  | keyof typeof currencyAndTaxDisplayRules
  | keyof typeof referenceInfoSourcingBacklogDisplayRules
  | keyof typeof projectInformationFeesDisplayRules
  | keyof typeof invoicingInfoDisplayRules
  | keyof typeof addressesDisplayRules
  | keyof typeof miscellaneousDisplayRules;

function getDisplayRulesByKey(key: DisplayRulesKey, statusIndex: number) {
  return (
    shippingInfoDisplayRules[key as keyof typeof shippingInfoDisplayRules]?.[statusIndex] ||
    currencyAndTaxDisplayRules[key as keyof typeof currencyAndTaxDisplayRules]?.[statusIndex] ||
    referenceInfoSourcingBacklogDisplayRules[key as keyof typeof referenceInfoSourcingBacklogDisplayRules]?.[
      statusIndex
    ] ||
    projectInformationFeesDisplayRules[key as keyof typeof projectInformationFeesDisplayRules]?.[statusIndex] ||
    invoicingInfoDisplayRules[key as keyof typeof invoicingInfoDisplayRules]?.[statusIndex] ||
    addressesDisplayRules[key as keyof typeof addressesDisplayRules]?.[statusIndex] ||
    miscellaneousDisplayRules[key as keyof typeof miscellaneousDisplayRules]?.[statusIndex] || ['Readlonly'] // Fallback value
  );
}

export function isReadOnlyFromDisplayRules(key: DisplayRulesKey, status: number) {
  const statusIndex = statuses.indexOf(status.toString());

  if (statusIndex === -1) {
    console.error('Status not found in statuses array');
    return true;
  }

  return getDisplayRulesByKey(key, statusIndex) === 'Readlonly' || getDisplayRulesByKey(key, statusIndex) === 'Output';
}
